import {ReportModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {ConsolidationReportData} from "./consolidation-report.data";

@Injectable()
export class ConsolidationReportModel extends ReportModel<ConsolidationReportData> {
    constructor(injector: Injector) {
        super(injector, ConsolidationReportData);
    }

}
